<fieldset class="scheduler-border">
  <legend class="scheduler-border" [class._largeTitle]="largeTitle" [i18n]="fieldsetTitleKey" *ngIf="fieldsetTitleKey"></legend>
  <ng-content select="app-data-filter-autocomplete, app-data-filter-form-autocomplete, input, div, small"></ng-content>
</fieldset>
